import React from 'react';
import styles from './index.module.scss';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

const PrivacyData: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <div className={styles['product-detail']}>
      <div className={styles['product-detail-title']}>{t('privacyData.title')}</div>
      <div className={styles['product-detail-html']}>
         <div className={`${styles['product-detail-html1']} ${styles['mg-b']}`}>{t('privacyData.html1')}</div>
         <div className={`${styles['product-detail-html2']} ${styles['font16']}`}>{t('privacyData.html2')}</div>
         <div className={`${styles['font14']} ${styles['mg-b']}`}>{t('privacyData.html3')}</div>
         <div className={`${styles['font16']}`}>{t('privacyData.html4')}</div>
         <div className={`${styles['font14']} ${styles['mg-b']}`}>{t('privacyData.html5')}</div>
         <div className={`${styles['font16']}`}>{t('privacyData.html6')}</div>
         <div className={`${styles['font14']} ${styles['mg-b']}`}>{t('privacyData.html7')}</div>
         <div className={`${styles['font16']}`}>{t('privacyData.html8')}</div>
         <div className={`${styles['font14']}`}>{t('privacyData.html9')}</div>
         <div className={`${styles['product-detail-html10']} ${styles['font14']}`} onClick={() => navigate('/yourtownloop/yourProfile')}>{t('privacyData.html10')}</div>
         <div className={`${styles['font14']}`}>{t('privacyData.html11')}</div>
      </div>
    </div>
  );
};

export default PrivacyData;


